import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer-container">
                <p>Copyright &copy; 2025. Todos los derechos reservados.</p>
        </footer>
    );
}

export default Footer;